import React from 'react';

export default class Wallitem extends React.Component {
    render() {
        const data = this.props.value
        return (
            <div className="card_content">
                <img src={data && data.cardimage} className="img-fluid" alt="" />
                {/* <h4>Manish Vajpayee</h4>
                <h5>Republic Day</h5> */}
                <h6>
                    <img onClick={(elem) => { this.props.likedislike(data.id, elem) }} 
                    id={data.id} attr-parameter={data.is_liked == 0 || data.is_liked == "" ? "like" : "unlike"} 
                    src={data.is_liked != '0' ? "/assets/img/liked1.png" : "/assets/img/like.png"} 
                    className="img-fluid img_like" alt="" />
                    <span id={"count_id_" + data.id}>{data.like_count}</span>
                </h6>
            </div>
        )
    }
}